<template>
  <div >
    <!-- 顶部工具条 -->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label='关键字:'>
          <el-input placeholder="请输入"  v-model="filters.keyWord" clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="资料类型:">
          <el-select v-model="filters.type" clearable placeholder="请选择">
            <el-option 
              v-for="item in TypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="是否启用:">
          <el-select v-model="filters.isEnable" clearable placeholder="请选择">
            <el-option 
              v-for="item in isEnableOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 表格 -->
    <el-table 
      v-loading="loading" 
      :data="tableData" 
      style="width:100%" 
      border 
      highlight-current-row 
      @current-change="handlerowChange"
    >
     <el-table-column  label="资料名称" width="" align="center" prop="Name"></el-table-column>
      <el-table-column  label="资料类型" width="" align="center" prop="Type"></el-table-column>
     
      <el-table-column  label="创建时间" width="" align="center" prop="CreateTime" :formatter="formatCreateTime"></el-table-column>
      <el-table-column label="启用标识" width="" align="center" prop="IsEnable">
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.IsEnable == true ? 'success' : 'danger'" disable-transitions>{{scope.row.IsEnable == true ? "启用":"禁用"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <!-- <a  :href="scope.row.FileUrl" style="color: #409EFF;cursor:pointer;">预览</a> -->
          <span style="color: #409EFF;cursor:pointer;" @click="handlePreview(scope.row)">预览</span>

        </template> 
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-col :span="24" class="pageBarContainer">
      <el-pagination
        small
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        :current-page="pages.pageIndex"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        class="pageBarContainer"
        >
      </el-pagination>
    </el-col>    
    <!-- 新增/编辑 -->
    <el-dialog
      :title="isAdd?'新增':'编辑'"
      :visible.sync="FormVisible"
      :close-on-click-modal="false"
      width="50%"
      >
      <el-form :model="Form" label-width="110px" label-position="center" ref="FormRef" :rules="FormRules">
          <el-form-item label="资料名称:" prop="Name" with="100">
            <el-input  placeholder="请输入资料名称" v-model="Form.Name"></el-input>
          </el-form-item>
           <el-form-item label="文稿资料:" prop="QuestionsTitle" with="100">
            <el-upload
              :action="uploadObsDocumentFile"
              :headers="headers"
              :limit="3"
              accept=".ppt,.pptx,.txt,.pdf"
              :file-list="fileList"
              :on-success="(response,file,fileList)=>handleSuccess(response,file,fileList)">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" style="color:red;" >说明：可上传的文件类型 ppt/txt/pdf</div>
              <!-- 自定义文件列表插槽 -->
              <template slot="file" slot-scope="scope">
                <div class="el-upload-list__item">
                  <!-- 文件名称 -->
                  <span class="el-upload-list__item-name">{{ scope.file.name }}</span>
                  <!-- 自定义删除按钮 -->
                  <i 
                    class="el-icon-close el-upload-list__item-delete" 
                    @click="customDelete(scope.file)"
                  ></i>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item label="启用标识:" prop="IsEnable">
            <el-radio-group v-model="Form.IsEnable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="FormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="FormSubmit" :loading="loading">保 存</el-button>
      </span>
    </el-dialog>

     <!--新增预览弹窗 -->
    <el-dialog
      title="文件预览"
      :visible.sync="previewDialogVisible"
      width="80%"
      top="5vh"
      custom-class="pdf-preview-dialog"
      @close="closePreview"
    >
      <!-- 核心：使用 iframe 展示 FileUrl -->
      <!-- v-if 确保每次打开都重新加载 iframe，避免缓存问题 -->
      <div v-if="previewDialogVisible" class="iframe-container">
        <iframe
          :src="previewUrl"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// 数据请求
import {getDocMaterialPageList,deleteDocMaterial,addDocMaterial,updateDocMaterial ,uploadObsDocumentFile} from '@/api/api'
export default {
  components:{Toolbar},
  data(){
    return {
      isAdd:false,
      //是否启用
      isEnableOption:[
        {
          value:'0',
          label:'禁用'
        },
        {
          value:'1',
          label:'启用'
        }
      ],
      // 资料类型
      TypeOption:[
        {
          value:'0',
          label:'ppt'
        },
        {
          value:'1',
          label:'txt'
        },
        {
          value:'2',
          label:'pdf'
        },        
      ],
      // 筛选
      filters:{
        keyWord:null,
        type:null,
        isEnable:null
      },
      // 增删改查等按钮
      buttonList: [],
      // 表格中的数据
      tableData:[],
      // 分页
      pages:{
        pageArr:[10,20,30,40],
        pageSize:20,
        pageIndex:1,
        dataCount:1,
      },
      // 加载控制
      loading:false,
      // 新增数据
      Form:{
        Name:'',
        FileUrl:"",
        IsEnable:1,
        FileName:"",
        Type:""
      },
      FormRules:{
        Name:[{required:true,message:'请输入资料名称',trigger:'blur'}],
        IsEnable:[{required:true,message:'请选择启用状态',trigger:'change'}],
      },
      currentRow:null,
      FormVisible:false,
      fileList:[],
      uploadObsDocumentFile:null,
      previewDialogVisible:false,
      previewUrl:''
    }
  },
  methods:{
    getList(){
      this.loading = true
      var params = {
        keyWord:this.filters.keyWord,
        type:this.filters.type,
        isEnable:this.filters.isEnable,
        pageIndex:this.pages.pageIndex,
        pageSize:this.pages.pageSize,
       
      }
      getDocMaterialPageList(params).then(res => {     
        this.tableData = res.data.Response.Data
        this.pages.dataCount = res.data.Response.DataCount
        this.loading = false
      })
    },
    // 数据条数改变
    handleSizeChange(newSize){
      this.pages.pageSize = newSize   
      this.getList()
    },
    // 当前页改变
    handleCurrentChange(newPage){
      this.pages.pageIndex = newPage   
      this.getList()
    },
    // 表格当前行改变事件
    handlerowChange(row){
      this.currentRow = row
    },
    // 查询
    handleSearch() {  
      this.pages.pageIndex = 1
      this.getList()
    },
    // 新增
    handleAdd(){
      this.isAdd = true
      this.Form = {
        Name:'',
        FileUrl:'',
        IsEnable:1,
        FileName:"",
        Type:""
      }
      this.fileList = []
      this.$nextTick(() => {
        if (this.$refs['FormRef']) {
          this.$refs['FormRef'].clearValidate(); 
        }
      });
      this.FormVisible = true
    },

     // 编辑
    handleEdit(){
      this.isAdd = false
      if(!this.currentRow){
        this.$message({
          type:'error',
          message:'请选择要编辑的一行数据！'
        })
        return
      }
      this.Form = {
        Name:this.currentRow.Name,
        FileUrl:this.currentRow.FileUrl.split('image/')[1],
        IsEnable:this.currentRow.IsEnable,
        FileName:this.currentRow.FileName,
        Type:this.currentRow.Type
      }
      this.fileList = []
      let fileobj = {
        name :this.currentRow.FileName
      }
      this.fileList.push(fileobj)
      this.$nextTick(() => {
        if (this.$refs['FormRef']) {
          this.$refs['FormRef'].clearValidate(); 
        }
      });
      this.FormVisible = true;
    },
    // 删除
    handleDel(){
      if(!this.currentRow){
        this.$message({
          message: '请选择要删除的一行数据',
          type: 'error'
        })
        return
      }
      this.$confirm('确定要删除该行数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        var params = {
          id :this.currentRow.Id
        }
        deleteDocMaterial(params).then(res => {
          if(res.data.Success){
            this.loading = false
            this.$message({
              type:'success',
              message:res.data.Message
            })
            this.getList()
          }else{
            this.loading = false
            this.$message({
              type:"error",
              message:res.data.Message
            })
          }            
        })         
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          }); 
        })
    },
    // 新增/编辑 提交表单
    FormSubmit(){
      if(!this.Form.FileUrl || this.fileList.length<=0){
        this.$message.warning("请上传文稿资料")
        return;
      }
      this.$refs['FormRef'].validate((valid) => {
        if(valid){
          this.$confirm('确认提交吗？',"提示",{}).then(() => { 
            let params = {
               ...this.Form
            }
            this.loading = true
            if(this.isAdd){
               params.Id = 0  
              addDocMaterial(params).then(res => {
                if(res.data.Success) {
                  this.loading = false;
                  this.$message({
                      message: '新增成功',
                      type: 'success'
                  });
                  this.FormVisible = false;
                  this.$refs['FormRef'].resetFields();
                  this.getList();
                }else{
                  this.loading = false;
                  this.$message({
                    message:'新增失败',
                    type:'error'
                  })
                }
              })
            }else{
              params.Id = this.currentRow.Id
              updateDocMaterial(params).then(res => {
                if(res.data.Success) {
                  this.loading = false;
                  this.$message({
                      message: '更新成功',
                      type: 'success'
                  });
                  this.FormVisible = false;
                  this.$refs['FormRef'].resetFields();
                  this.getList();
                }else{
                  this.loading = false;
                  this.$message({
                    message:'新增失败',
                    type:'error'
                  })
                }
              })
            }
            
          })
        }
      })
    },
    handleSuccess(response,file,fileList){
      this.fileList = []
      this.fileList = [file]
      if(response.Success){
          this.$message.success(response.Message)
          this.Form.Type = file.raw.name.split('.').pop();
          this.Form.FileUrl = response.Response.weburl
          this.Form.FileName = response.Response.fileName
      }
    },
    customDelete(file){
        console.log("customDeletefile",file)
        this.fileList = this.fileList.filter(item => item.name !== file.name);
    },
    handlePreview(row) {
      if (!row.FileUrl) {
        this.$message.warning('该文件暂无预览链接');
        return;
      }
      let url = row.FileUrl;
      const fileExtension = row.FileUrl.split('.').pop().toLowerCase();
      if (fileExtension === 'ppt' || fileExtension === 'pptx') {
        // 使用微软的在线预览服务
        // 注意：FileUrl 必须是公网可访问的地址
        url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(row.FileUrl)}`;
      }
      this.previewUrl = url;
      this.previewDialogVisible = true;
    },
    closePreview() {
      this.previewUrl = '';
    },
    // 时间格式化
    formatCreateTime:function(row,column){
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    }, 
    callFunction(item) {
      this[item.Func].apply(this, item);
    },    
    getToken() {
      return localStorage.getItem("Token")
    },  
  },
  computed: {
    headers() {
      return{
        "Authorization": 'Bearer ' + this.getToken() // 直接从本地获取token就行
      }
    }
  },
  created(){
    this.getList()
  },
  mounted(){
    this.uploadObsDocumentFile = uploadObsDocumentFile;
    let routers = window.localStorage.router
    ? JSON.parse(window.localStorage.router)
    : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }

}
</script>

<style lang="stylus" scoped>
  .pageBarContainer{
    margin-top:20px;
		margin-bottom :20px
  }
  .special{
    display:flex!important;
    justify-content:center;
  }
  .checked .el-col p{
    display:inline-blocck!important;
    text-align:center!important;
  }
  .operation .el-col .el-button{
    display:block!important;
    margin:0 auto!important;
  }
  .judgeAnswer{
    vertical-align:middle!iportant;
    line-height:84px;
  }
  .answer{
    display:flex!important;
    align-items :center;
    height:45px;
  }
  /* 限制 iframe 容器的高度，防止撑破屏幕 */
.iframe-container {
  width: 100%;
  height: 70vh; /* 占据视口高度的 70% */
  background-color: #f0f2f5; /* 灰色背景，突出文档 */
}

iframe {
  display: block;
}
</style>